const o=110;export{o as CHAR_LIMIT};
